import React, {useEffect, useState} from 'react';
import "./Table.css";
import MoreDots from "../MoreDots/MoreDots";
import MyButton from "../MyButtons/MyButton";
import {useNavigate} from "react-router-dom";
import search_icon from "../../../Assets/icons/search-icon.svg";
import more from "../../../Assets/icons/expand_more.svg";
import empty from "../../../Assets/icons/dashboard_empty.svg"

const Table = ({ entity, columns, info, text, setSearchText}) => {
    const navigate = useNavigate()
    const [activeMenuId, setActiveMenuId] = useState(null);
    const [data, setData] = useState(info);
    const [search, setSearch] = useState('');

    const toggleMenu = (id) => {
        setActiveMenuId(activeMenuId === id ? null : id);
    };

    const updateSearch = () => {
        setSearchText(search);
    };

    useEffect(() => {
        setData(info);
    }, [info]);

    return (
        <div className={"constants__body"}>
            {entity === "constants" ? (
                <div className="search">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search bar"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <img
                        src={search_icon}
                        className="search-icon"
                        alt="Search Icon"
                        onClick={() => updateSearch()}
                    />
                </div>
            ) : (
                <div className={'search-dep-wrap'}>
                    <div className="search-dep">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Search bar"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <img
                            src={search_icon}
                            className="search-icon"
                            alt="Search Icon"
                            onClick={() => updateSearch()}
                        />
                    </div>
                    <MyButton
                        content={"Add +"}
                        onClick={() => navigate(`/${entity}/add`)}
                        isBlue={true}/>
                </div>
            )}
            <div className={"constants__type"}>
                {entity === "constants" && (
                    <div className={"drop_bar"}>
                        Security and authentication
                        <img src={more} alt={"more"} />
                    </div>
                )}
                <table border="1" cellPadding="8" cellSpacing="0" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead className={"table__head"}>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col}</th>
                        ))}
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className={"table__content"}>
                    {data.length === 0 && entity === "departments" ? (
                        <tr>
                            <td colSpan={columns.length + 1} className={"empty__table"}>
                                <div className={"empty__img"}>
                                    <img src={empty} alt="empty"/>
                                </div>
                                <div className={"empty__text"}>
                                    <h6>No departments created yet.</h6>
                                    <h6>Start by adding a department to organize your institution's structure.</h6>
                                </div>
                            </td>
                        </tr>
                    ) : (
                        data.map((item) => (
                            <tr key={item.id}>
                                {columns.map((col, index) => (
                                    <td key={index}>{item[col.toLowerCase()] || item.name}</td>
                                ))}
                                <td style={{ position: "relative", display: "inline-block", float: 'right'}}>
                                    <MoreDots
                                        id={item.id}
                                        entity={entity}
                                        isOpen={activeMenuId === item.id}
                                        onToggle={() => toggleMenu(item.id)}
                                        setData={setData}
                                        text={text}
                                    />
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Table;
